export const requestNewsQuery = () => `
    query news($day: String!, $symbol: String!) {
        news(day: $day, symbol: $symbol) {
            start
            limit
            totalCount
            feedItems {
                id
                title
                body
                link
                source
                paywall
                fullSource
                publishDate
                publishTimstamp
                writtenInLang
            }
        }
    }
`;